export const FETCH_IMAGES = 'FETCH_IMAGES'